import { createSlice } from '@reduxjs/toolkit';
import { submitGuidelines } from './Utils/GuidelineUtils';

const initialState = {
  id: '',
  membership_id: '',
  day: '',
  title_group: '',
  items: [],
  isLoading: false,
};

const addGuidelineSlice = createSlice(
  {
    name: 'addGuideline',
    initialState: initialState,
    reducers: {
      setFieldGuideline: (state, action) => {
        const { field, value } = action.payload;
        state[field] = value;
      },
      resetStateGuideline: (state) => {
        return initialState;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(submitGuidelines.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(submitGuidelines.fulfilled, (state) => {
          state.isLoading = false;
        })
        .addCase(submitGuidelines.rejected, (state, action) => {
          state.isLoading = false;
          console.log(action.error.message, "error action")
        })
    }
  }
);

export const { setFieldGuideline, resetStateGuideline } = addGuidelineSlice.actions;

export default addGuidelineSlice.reducer;